// achatsMobileApi.js — les endpoints dont l'écran Achats mobile a besoin et qui ne
// figurent pas dans l'objet `api` de GestionAchat.tsx. Tout le reste (liste, détail,
// articles, suppression/annulation/restauration) passe par cet objet `api`.
import API_CONFIG from "../../config/api";

const BASE_URL = API_CONFIG.BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken");
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

/** Paiements d'une commande. */
export async function fetchOrderPayments(orderId, { companyId, warehouseId } = {}) {
  const params = new URLSearchParams();
  if (companyId) params.set("company_id", String(companyId));
  if (warehouseId) params.set("warehouse_id", String(warehouseId));
  const qs = params.toString();

  const res = await fetch(
    `${BASE_URL}/api/orders/${orderId}/payments${qs ? `?${qs}` : ""}`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) throw new Error(`Erreur ${res.status} lors du chargement des paiements`);

  const data = await res.json();
  if (Array.isArray(data)) return data;
  return Array.isArray(data?.payments) ? data.payments : [];
}

/**
 * Téléchargement du PDF généré côté serveur (GestionAchat.tsx:3899-3933).
 * L'endpoint diffère selon le type de commande.
 */
export async function downloadOrderPdf(order, orderType) {
  const endpoint =
    orderType === "purchase_order"
      ? `/api/orders/${order.id}/purchase-order-pdf?download=true`
      : `/api/orders/${order.id}/invoice?download=true`;

  const res = await fetch(`${BASE_URL}${endpoint}`, { headers: getAuthHeaders() });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || res.statusText);
  }

  const blob = await res.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = `${order.invoice_number || order.id}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
}
